/**
 * pageHelpStorage.ts — tiny localStorage wrapper for the page-help "seen"
 * flag. The PageHelpButton pulses softly until the guide has been opened
 * once on that page; the flag persists per browser.
 *
 * Pure + defensive (localStorage can throw in private mode) so it is
 * unit-testable without a component mount.
 */

import type { PageHelpKey } from './helpTypes';

export const pageHelpSeenKey = (pageKey: PageHelpKey): string =>
  `belab.pageHelp.seen.${pageKey}`;

/** True once the user has opened this page's guide at least once. */
export function hasSeenPageHelp(pageKey: PageHelpKey): boolean {
  try {
    return window.localStorage.getItem(pageHelpSeenKey(pageKey)) === '1';
  } catch {
    return true; // storage unavailable → don't pulse forever
  }
}

export function markPageHelpSeen(pageKey: PageHelpKey): void {
  try {
    window.localStorage.setItem(pageHelpSeenKey(pageKey), '1');
  } catch {
    // best-effort only
  }
}
